import React from 'react';
import './FileBreadcrumb.scss';
import Home from 'react-ionicons/lib/Home';
import Folder from 'react-ionicons/lib/FolderOpen';
import ArrowLeft from 'react-ionicons/lib/ChevronForward';

export const DFLT_ICO_PROPS = {
    height: '26px',
    width:  '26px',
    color: 'inherit',
    className: 'icon-cls'
};

export const Item = ({
    folder,
    index, indexMax,
    onClick
}) => {
    let body = null;
    let arrow = null;
    let isEnd = (index === indexMax);
    if (folder.id === 'root') {
        body = (
            <Home {...DFLT_ICO_PROPS} className='icon-cls iccls-highlight' />
        );
    } else {
        body = (
            <>
                <Folder {...DFLT_ICO_PROPS} />{folder.name}
            </>
        );
    }
    if (!isEnd) {
        arrow = (
            <>
                <ArrowLeft {...DFLT_ICO_PROPS} className='icon-cls iccls-highlight' />
            </>
        );
    }
    return (
        <>
            <div className={['fbm-item', (isEnd ? 'current' : 'selectable')].join(' ')} onClick={onClick}>
                {body}
            </div>
            {arrow ? <div className="fbm-item">{arrow}</div> : null}
        </>
    );
};

export const FileBreadcrumb = ({ breadcrumb, onSelectFolderIndex }) => {
    const folders = (Array.isArray(breadcrumb) ? breadcrumb : [ { id: 'root' }]);
    const indexMax = folders.length - 1;
    return (
        <div className="file-breadcrumb-module">
            {folders.map((folder, idx) => 
                <Item
                    key={idx}
                    folder={folder}
                    index={idx}
                    indexMax={indexMax}
                    onClick={() => (idx < indexMax ? onSelectFolderIndex(idx) : () => {})}
                />
            )}
        </div>
    );
};

FileBreadcrumb.Item = Item;

export default FileBreadcrumb;